import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import _ from "lodash";
import ReactPaginate from "react-paginate";

function PtientIntentList(props) {
  const [IntentList, setIntentList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedPosts, setpaginatedPosts] = useState();
  const navigate = useHistory();
  // const history=useHistory();
  const PtName = localStorage.getItem("PatName");
  const PtGender = localStorage.getItem("PatGender");
  const PtId = localStorage.getItem("PatQusId");
  const backchar = localStorage.getItem("Backvalue");
  const UserRole = localStorage.getItem("URole");

  const pageSize = 10;
  // let limit = 10;

  useEffect(() => {
    LoadIntents();
  }, [pageSize]);

  const LoadIntents = () => {
    const datavalue = {
      id: PtId,
      key: "Not",
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/getIntentsByPid`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      //console.log("list", res.data)
      setIntentList(res.data);
      setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
    });
  };

  const pageCount = IntentList ? Math.ceil(IntentList.length / pageSize) : 0;
  if (pageCount === 1) return null;
  const pages = _.range(1, pageCount + 1);

  const handlePageClick = async (data) => {
    //console.log("pageno", data.selected + 1)
    let currentPage = data.selected + 1;
    setCurrentPage(currentPage);
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedPost = _(IntentList)
      .slice(startIndex)
      .take(pageSize)
      .value();
    setpaginatedPosts(paginatedPost);
  };

  const EditIntents = (valid) => {
    localStorage.setItem("IntentInfo", valid);
    //console.log("the vaue", valid)
    localStorage.removeItem("BackIntent");
  };
  const deleteIntent = (value) => {
    //console.log("the vaue", value)

    const datavalue = {
      id: value,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeleteQuestionAns`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions)
      .then((res) => {
        //console.log("get value", res);
        //console.log("success")
        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };
  const InsertQues = () => {
    // localStorage.setItem('PatQusId', valid);
    localStorage.removeItem("BackQues");

    //console.log("the vaue")
  };
  const BackFunc = () => {
    // backchar == 'dashboard' ? navigate.push('/index') : navigate.push('/PatientList');
    // UserRole === "Admin" ?  navigate.push('/PatientList'): navigate.push('/ManagerPatientList')
    UserRole === "Admin"
      ? navigate.push("/CaseList")
      : navigate.push("/ManagerPatientList");
  };

  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title">List of Questions and Answers</div>
                <p className="custom-cursor">
                  Case ID:<span className="patietid me-3 ms-2">{PtId}</span>Case
                  Name:<span className="page me-3 ms-2">{PtName}</span>
                  Gender:<span className="page me-3 ms-2">{PtGender}</span>
                </p>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn btn-primary d-inline-block"
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-head">
                      <header>
                        <div className="tools">
                          <Link to="/PatientQues" onClick={() => InsertQues()}>
                            <button
                              type="button"
                              className="btn btn-primary  py-2 px-3"
                            >
                              Add Question
                            </button>
                            {/* <i className=""> Add Question</i> */}
                          </Link>
                        </div>
                      </header>
                    </div>
                    <div className="card-body ">
                      <div className="table-responsive">
                        <table className="table table-striped custom-table table-hover">
                          <thead>
                            <tr>
                              <th>Question ID</th>
                              <th>Intents</th>
                              <th>Answer 1</th>
                              <th>Answer 2</th>
                              <th>Emotion</th>
                              <th>Assessment</th>
                              {/* <th>Gender</th> */}
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedPosts &&
                              paginatedPosts.length > 0 &&
                              paginatedPosts.map((item) => (
                                <tr>
                                  <td
                                    className="text-left"
                                    style={{ width: "100px" }}
                                  >
                                    {item.id}
                                  </td>
                                  <td>
                                    <span>{item.intents}</span>
                                  </td>
                                  <td className="text-left">
                                    {item.responce1}
                                  </td>
                                  <td className="text-left">
                                    {item.responce2}
                                  </td>
                                  <td className="text-left">
                                    {item.emotion == "Neural"
                                      ? "Neutral"
                                      : item.emotion}
                                  </td>
                                  <td className="text-left">{item.emo_Type}</td>
                                  {/* <td className="text-left">{item.gender}</td> */}
                                  <td className="action-cell">
                                    <Link
                                      to="/PatientUpdateIntents"
                                      onClick={() => EditIntents(item.id)}
                                      className="btn btn-primary btn-xs py-2"
                                    >
                                      <i className="fa fa-pencil"></i>
                                    </Link>

                                    <button
                                      className="btn btn-danger btn-xs py-2"
                                      onClick={() => deleteIntent(item.id)}
                                    >
                                      <i className="fa fa-trash-o "></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination justify-content-center"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        activeClassName={"active"}
                        previousClassName={"page-item"}
                        nextClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextLinkClassName={"page-link"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PtientIntentList;
